import { JSX } from './jsx'

interface Attributes {
	[key: string]: string | boolean | undefined | null | ((e: Event) => unknown) | JSX.CSSProperties
	[key: `on${string}`]: (e: Event) => unknown
	[key: `class:${string}`]: boolean
	[key: `class_${string}`]: boolean
	class?: string
	style?: JSX.CSSProperties | string
	// @ts-ignore
	children?: JSX.Child[] | JSX.Child | undefined | null
}

const nameMap = new Map([
	['for', 'htmlFor']
])

function isIterable<T>(v: Iterable<T> | unknown): v is Iterable<T> {
	return v != null && (v as any)[Symbol.iterator] !== undefined
}

class ClassMultiSet {
	element: HTMLElement
	_classes: Map<string, number>

	constructor(element: HTMLElement) {
		this.element = element
		this._classes = new Map()
	}

	_change(class_: string, change: number) {
		const newCount = (this._classes.get(class_) ?? 0) + change
		this._classes.set(class_, newCount)
		newCount > 0 ? this.element.classList.add(class_) : this.element.classList.remove(class_)
		return newCount
	}
	add(class_: string) {
		this._change(class_, +1) == 1
	}
	remove(class_: string) {
		this._change(class_, -1) == 0
	}
}

type StrixElement<E extends HTMLElement> = E & {
	strixClassMultiSet: ClassMultiSet
}

function strixElement<E extends HTMLElement>(e: E) {
	const e2 = e as StrixElement<E>
	if (e2.strixClassMultiSet == undefined)
		e2.strixClassMultiSet = new ClassMultiSet(e)
	return e2
}

export const h = (type: string, props?: Attributes, ...children: JSX.Child[]): HTMLElement => {
	props = props ?? {}

	const e = strixElement(document.createElement(type))

	if (props.class !== undefined) {
		// TODO add some indirection, so this won't override class:* attributes.
		e.className = props.class
	}
	if (props.style !== undefined) {
		if (typeof props.style === 'string') {
			// @ts-ignore: it's actually not read-only
			e.style = props.style
		} else {
			for (const [k, v] of Object.entries(props.style)) {
				;(e.style as any)[k] = v
			}
		}
	}
	for (const [name, value] of Object.entries(props)) {
		if (name.startsWith('v-') || name === 'class' || name === 'style') {
		} else if (name.startsWith('class:') || name.startsWith('class_')) {
			const className = name.substring('class:'.length)
			value ? e.classList.add(className) : e.classList.remove(className)
		} else if (name.startsWith('on')) {
			e.addEventListener(name.toLowerCase().substring(2), value as (e: Event) => unknown)
		} else {
			;(e as any)[nameMap.get(name) ?? name] = value
		}
	}

	for (const child of children) {
		const newNodes = ((): Iterable<Node | undefined> => {
			if (child === undefined || child === null) {
				return [] as Node[]
			} else if (child instanceof Set) {
				return child.values()
			} else if (child instanceof Map) {
				return child.values()
			} else if (child instanceof Node) {
				return [child]
			} else if (typeof child == 'string') {
				return [document.createTextNode(child)]
			} else if (typeof child == 'number') {
				return [document.createTextNode(child.toString())]
			} else if (isIterable(child)) {
				return child
			} else {
				console.log(child)
				throw new Error('Invalid child type')
			}
		})()

		for (const node of newNodes) {
			if (node === undefined) {
				continue
			}
			try {
				e.appendChild(node)
			} catch (e) {
				console.log('CANT APPEND', node, e)
			}
		}
	}

	return e
}

export function jsx(type: string, config: Attributes, maybeKey: string | undefined) {
	const oldConfig = {...config}
	delete oldConfig.children
	// @ts-ignore
	const children = config.children == undefined ? [] : (config.children[Symbol.iterator] ? config.children : [config.children])
	// @ts-ignore
	return h(type, oldConfig, ...children)
}

export function jsxDEV(type: string, config: Attributes, maybeKey: string | undefined, isStaticChildren: any, source: any, self: any) {
	return jsx(type, config, maybeKey)
}
